// extracted by mini-css-extract-plugin
export default {"titleBox":"ListingsManagementPage_titleBox__+1xuj"};